import { config as aimReader } from "../../config/aim_reader";
import { config as aimTag } from "../../config/aim_tag";
import { Environment } from "../../types/environment";
import { Version } from "../../types/version";

export const getConfig = (env: Environment, version: Version) => version === "aim_reader"
    ? aimReader[env]
    : aimTag[env];
